import type { RateLineProposalStatus } from '@chukua/common';
import { Tag } from 'antd';
import { PROPOSAL_STATUS_LABELS } from '../../../policies/rate-card-labels';

const COLORS: Record<RateLineProposalStatus, string> = { draft: 'default', pending_approval: 'warning', approved: 'success', withdrawn: 'default' };

/** "Draft" or "Pending approval" wherever a proposal could be mistaken for a published price. */
export function ProposalStatusTag({ status }: { status: RateLineProposalStatus }) {
  return <Tag color={COLORS[status]}>{PROPOSAL_STATUS_LABELS[status]}</Tag>;
}
